import { IBetslipSourcePageState, SourcePageType } from '../../model/edit-mybet/edit-bet-init';

export const defaultSourcePageState: IBetslipSourcePageState = {
    pageType: SourcePageType.MyBets,
    options: null,
};
